var map = {
	"./act_as_toggle_controller.js": 11,
	"./course_download_controller.js": 12,
	"./document_form_controller.js": 13,
	"./hello_controller.js": 15,
	"./modal_controller.js": 16,
	"./partecipation_controller.js": 17,
	"./tagify_controller.js": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;